// extracted by mini-css-extract-plugin
module.exports = {"actions":"styles_actions__1e4f1","col":"styles_col__1rTgo"};